import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Row, Button } from '@evertel/web/ui'
import { EmojiButton } from '@evertel/web/emojis'
import { APIDataReaction } from '@evertel/types'
import { Reaction } from './Reaction'
import { useService } from '@evertel/di'
import { SessionService } from '@evertel/session/SessionService'
import { MessageWallContext } from '@evertel/message'

interface ReactionProps {
    messageId: number
    reactions: APIDataReaction[]
    onSelectReaction?: (reaction: APIDataReaction) => void
    onShowEmojiPicker: (target: string) => void
    onShowReactedBy?: () => void
    showPickerButton?: boolean
    showClickAnimation?: boolean
    emojiButtonId: string
    showCountLink?: boolean
    canReact?: boolean
}

const ReactionBar: React.FC<ReactionProps> = observer(({
    messageId,
    reactions,
    onSelectReaction,
    onShowEmojiPicker,
    onShowReactedBy,
    emojiButtonId,
    showCountLink,
    showPickerButton,
    showClickAnimation,
    canReact = true,
    ...otherProps
}) => {

    const sessionService = useService(SessionService, [])

    const { focusedMessageId } = useContext(MessageWallContext)

    const isFocused = focusedMessageId === messageId

    const count = reactions?.reduce((sum: number, r: any) => sum + r.count, 0) ?? 0

    //console.log('REACTIONS', reactions)


    return (
        <Row valign="start" align="start"
            {...otherProps}
            className={`reaction-bar${isFocused ? ' focused' : ''}`}
        >
            {reactions.slice().sort((a: any, b: any) => a.id - b.id).map((reaction: APIDataReaction) => {
                const isMyReaction = !!reaction.reactedByThrough?.some(r => r.blueUserId === sessionService.currentUserId)

                return (
                    <Reaction
                        key={reaction.id}
                        emoji={reaction.text}
                        count={reaction.count}
                        isMyReaction={isMyReaction}
                        {...(canReact) && { onSelect: onSelectReaction }}
                        showClickAnimation={showClickAnimation && canReact}
                    />
                )
            })}
            <div className="d-flex" style={{ marginBottom: -12 }}>
                {(showPickerButton && canReact) &&
                    <EmojiButton
                        id={emojiButtonId}
                        onClick={() => onShowEmojiPicker(`#emojiButton-${messageId}`)}
                    />
                }
                {(showCountLink) &&
                    <Button
                        color="link"
                        size="sm"
                        onClick={onShowReactedBy}
                        className="ms-2 p-0 reaction-link"
                    >
                        <small>{count} {(count === 1) ? 'reaction' : 'reactions'}</small>
                    </Button>
                }
            </div>
        </Row>
    )
})

export { ReactionBar }
